<div class="my-apts animate-fade-in">

  <!-- Header -->
  <header class="my-apts__header stagger-1">
    <div>
      <h1>Mis turnos</h1>
      <p>Tus reservas activas y el historial de consultas.</p>
    </div>
    <button class="btn-new" routerLink="/booking">
      <span class="material-symbols-outlined">add</span>
      Nueva reserva
    </button>
  </header>

  <!-- Skeleton loading -->
  <div class="skeleton-list" *ngIf="isLoading">
    <div class="skeleton-apt" *ngFor="let i of [1,2,3]">
      <app-skeleton width="48px" height="48px" radius="var(--radius-lg)"></app-skeleton>
      <div class="skeleton-apt__lines">
        <app-skeleton width="200px" height="1rem"></app-skeleton>
        <app-skeleton width="140px" height="0.75rem"></app-skeleton>
        <app-skeleton width="90px" height="0.75rem"></app-skeleton>
      </div>
    </div>
  </div>

  <!-- Summary pills -->
  <div class="summary-strip stagger-2" *ngIf="!isLoading">
    <div class="summary-pill">
      <span class="material-symbols-outlined summary-pill__icon summary-pill__icon--upcoming">
        calendar_clock
      </span>
      <div>
        <span class="summary-pill__value">{{ upcoming.length }}</span>
        <span class="summary-pill__label">Próximos</span>
      </div>
    </div>
    <div class="summary-pill">
      <span class="material-symbols-outlined summary-pill__icon summary-pill__icon--past">
        history
      </span>
      <div>
        <span class="summary-pill__value">{{ past.length }}</span>
        <span class="summary-pill__label">Pasados</span>
      </div>
    </div>
  </div>

  <!-- Tabs -->
  <div class="tabs stagger-3" *ngIf="!isLoading">
    <button
      class="tab"
      [class.tab--active]="activeTab === 'upcoming'"
      (click)="activeTab = 'upcoming'"
    >
      Próximos
      <span class="tab__count" *ngIf="upcoming.length">{{ upcoming.length }}</span>
    </button>
    <button
      class="tab"
      [class.tab--active]="activeTab === 'past'"
      (click)="activeTab = 'past'"
    >
      Historial
    </button>
  </div>

  <!-- Empty state -->
  <div class="empty-state stagger-4" *ngIf="!isLoading && displayList.length === 0">
    <span class="material-symbols-outlined">
      {{ activeTab === 'upcoming' ? 'event_available' : 'event_note' }}
    </span>
    <p *ngIf="activeTab === 'upcoming'">No tenés turnos próximos.</p>
    <p *ngIf="activeTab === 'past'">Todavía no tenés historial de turnos.</p>
    <button class="btn-new" routerLink="/booking" *ngIf="activeTab === 'upcoming'">
      <span class="material-symbols-outlined">add</span>
      Reservar ahora
    </button>
  </div>

  <!-- Appointment list -->
  <div class="apt-list stagger-4" *ngIf="!isLoading && displayList.length > 0">
    <div
      class="apt-item"
      *ngFor="let apt of displayList"
      [class.apt-item--cancelled]="apt.status === 'cancelled'"
      [class.apt-item--fading]="cancellingId === apt.id"
    >
      <!-- Date column -->
      <div class="apt-item__date">
        <span class="apt-item__day">{{ getDayNumber(apt.date) }}</span>
        <span class="apt-item__month">{{ getMonthShort(apt.date) }}</span>
      </div>

      <!-- Divider -->
      <div class="apt-item__line">
        <div class="apt-item__dot" [class.apt-item__dot--confirmed]="apt.status === 'confirmed'"
             [class.apt-item__dot--pending]="apt.status === 'pending'"
             [class.apt-item__dot--cancelled]="apt.status === 'cancelled'">
        </div>
      </div>

      <!-- Info -->
      <div class="apt-item__info">
        <div class="apt-item__top">
          <span class="apt-item__service">{{ apt.serviceType }}</span>
          <span class="apt-item__status-chip"
            [class.apt-item__status-chip--confirmed]="apt.status === 'confirmed'"
            [class.apt-item__status-chip--pending]="apt.status === 'pending'"
            [class.apt-item__status-chip--cancelled]="apt.status === 'cancelled'"
          >
            <span class="material-symbols-outlined">
              {{ apt.status === 'confirmed' ? 'verified' : apt.status === 'pending' ? 'hourglass_top' : 'cancel' }}
            </span>
            {{ statusLabel(apt.status) }}
          </span>
        </div>

        <div class="apt-item__meta">
          <span>
            <span class="material-symbols-outlined">schedule</span>
            {{ apt.time }} hs · {{ apt.duration }} min
          </span>
          <span>
            <span class="material-symbols-outlined">person</span>
            {{ apt.professionalName }}
          </span>
        </div>

        <p class="apt-item__notes" *ngIf="apt.notes">
          <span class="material-symbols-outlined">edit_note</span>
          {{ apt.notes }}
        </p>

        <!-- Actions: solo en próximos no cancelados -->
        <div class="apt-item__actions" *ngIf="activeTab === 'upcoming' && apt.status !== 'cancelled'">
          <button class="apt-action apt-action--reschedule" (click)="reschedule(apt)">
            <span class="material-symbols-outlined">edit_calendar</span>
            Reprogramar
          </button>
          <button class="apt-action apt-action--calendar" (click)="addToGoogleCalendar(apt)" title="Agregar a Google Calendar">
            <span class="material-symbols-outlined">event</span>
            Google Cal
          </button>
          <button class="apt-action apt-action--ics" (click)="downloadIcs(apt)" title="Descargar .ics">
            <span class="material-symbols-outlined">download</span>
            .ics
          </button>
          <button class="apt-action apt-action--cancel" (click)="cancelAppointment(apt)">
            <span class="material-symbols-outlined">cancel</span>
            Cancelar
          </button>
        </div>
      </div>
    </div>
  </div>

</div>
